import type { DatasetEnvironmentRegistry } from '~/engine/scene/DatasetEnvironmentRegistry';
import { localization } from '~/i18n';
import { enqueueSnackbar } from '~/utils/notifications';
import { redactDicomUids } from '~/utils/phiRedaction';

/**
 * Saves every resident grid Environment's contour edits to the domain. Returns
 * true when every save succeeded, and false after a failure it has already
 * reported to the user.
 *
 * Grid contour edits live only in the resident Environments' SDF textures, so
 * every boundary that tears tiles down, changes what they draw, or reads
 * contours back from the domain must flush first. Saving is idempotent, so a
 * second flush costs nothing.
 *
 * @param consequence What the user is told follows from a failed save, in
 *     the user's language.
 */
export function flushGridContourEdits(
    registry: Pick<DatasetEnvironmentRegistry, 'saveAllResidentChanges'>,
    consequence: string
): boolean {
    try {
        registry.saveAllResidentChanges();
        return true;
    } catch (error) {
        // The failures carry series UIDs.
        console.error(
            'Saving grid contour edits to the domain failed.',
            redactDicomUids(error)
        );
        enqueueSnackbar(
            localization.t('contouring.gridSaveFailed', { consequence }),
            { variant: 'error' }
        );
        return false;
    }
}
